// AB#1872 — pure, testable row-state → overflow-menu enumeration.
//
// Extracted from CategoriesPage so it can be unit-tested in isolation WITHOUT
// pulling the page's heavy dependency graph (zod / @hookform/resolvers via the
// edit modal), which CRA's jest transformIgnorePatterns does not transpile.
//
// AB#1872 collapsed the lifecycle to a single Active ↔ Deactivated axis and
// removed the entire approval axis (Pending/Approved/Rejected). The overflow
// menu is now derived ONLY from `archivedAt`:
//   - Deactivated (archivedAt != null) → []        (Reactivate is an inline button)
//   - Active      (archivedAt == null) → ['edit','deactivate']
//
// `deactivate` opens the blocking impact dialog (AB#1871).

import { type Category } from '../../../types/api-responses';

/** AB#1872 — `archivedAt != null` is the sole "deactivated" signal. */
export const isCategoryDeactivated = (c: Category): boolean => c.archivedAt != null;

export type CategoryRowAction = 'edit' | 'deactivate';

/**
 * Ordered overflow-menu action keys for a category row.
 *
 * Matrix (per row state):
 *   - Deactivated (archivedAt != null) → []                  (Reactivate is inline)
 *   - Active      (archivedAt == null) → ['edit','deactivate']
 */
export const buildCategoryRowActions = (c: Category): CategoryRowAction[] => {
    // Deactivated rows: overflow is empty — Reactivate is surfaced inline.
    if (isCategoryDeactivated(c)) return [];
    return ['edit', 'deactivate'];
};
